<!--nav1-->
<app-main-nav-bar></app-main-nav-bar>
<!--page-->
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div [ngClass]="imageClass ? imageClass : 'card-heading-health-family'"></div>
      <div class="card-body">
        <h3 class="title">هشتگ بیمه، دستیار شخصی بیمه</h3>
        <br>
        <div *ngIf="mobileMode">
          <p>
            برای ورود یا ثبت نام شماره همراه خود را وارد نمایید
            <br>
          </p>
          <br>
          <app-input-field [dataType]="['text', 11]" [Icon]="true" [fieldLabel]="'شماره همراه'" [fieldName]="'mobile'"
                           [Group]="loginForm">
          </app-input-field>
          <br>
          <br>
          <app-custom-button
            [disabled]="!loginForm.valid"
            [Show]="true"
            [LabelText]="'دریافت رمز'"
            [BackButton]="false"
            (OnClick)="getCode()"
          ></app-custom-button>
        </div>
        <div *ngIf="!mobileMode">
          <p>
            کد تایید به شماره {{loginForm.controls.mobile.value}} ارسال شد
            <br>
          </p>
          <br>
          <app-input-field [dataType]="['text', 5]" [Icon]="true" [fieldLabel]="'کد تایید'" [fieldName]="'securityCode'"
                           [Group]="codeSubmissionForm">
          </app-input-field>
          <br>
          <p>{{timeLeft}}</p>
          <div class="row">
            <a (click)="resendCode()" style="float: right; cursor: pointer;"><p>شماره همراه را اشتباه وارد کردید؟</p>
            </a>
          </div>
          <app-custom-button
            [disabled]="!codeSubmissionForm.valid"
            [Show]="true"
            [LabelText]="'ورود'"
            [BackButton]="timeLeft === 0"
            [backButtonLabel]="'ارسال مجدد'"
            (OnGoBack)="resendCode()"
            (OnClick)="submitCode()"></app-custom-button>
        </div>
      </div>
    </div>
  </div>
</div>
